document.addEventListener('DOMContentLoaded', () => {
  setBeforeAfterHeaderHeight();
  initBeforeAfterSections();
});

window.addEventListener('load', () => {
  setBeforeAfterHeaderHeight();
});

window.addEventListener(
  'resize',
  debounceBeforeAfter(() => {
    setBeforeAfterHeaderHeight();
  }, 100)
);

document.addEventListener('shopify:section:load', (event) => {
  setBeforeAfterHeaderHeight();

  const section = event.target.querySelector(
    '[data-before-after-section]'
  );

  if (section) {
    initBeforeAfterSection(section);
  }
});

/* =========================
   HEADER HEIGHT
========================= */

function setBeforeAfterHeaderHeight() {
  const header = document.querySelector(
    '.custom-header.custom-header--fixed'
  );

  if (!header) {
    document.documentElement.style.setProperty(
      '--before-after-header-height',
      '0px'
    );

    return;
  }

  const headerHeight =
    header.getBoundingClientRect().height;

  document.documentElement.style.setProperty(
    '--before-after-header-height',
    `${headerHeight}px`
  );
}

/* =========================
   INITIALIZE SECTIONS
========================= */

function initBeforeAfterSections() {
  const sections = document.querySelectorAll(
    '[data-before-after-section]'
  );

  if (!sections.length) {
    return;
  }

  sections.forEach((section) => {
    initBeforeAfterSection(section);
  });
}

/* =========================
   INITIALIZE COMPARISONS
========================= */

function initBeforeAfterSection(section) {
  const comparisons = section.querySelectorAll(
    '[data-before-after]'
  );

  if (!comparisons.length) {
    return;
  }

  comparisons.forEach((comparison) => {
    if (
      comparison.dataset.beforeAfterInitialized === 'true'
    ) {
      return;
    }

    const range = comparison.querySelector(
      '[data-before-after-range]'
    );

    if (!range) {
      return;
    }

    comparison.dataset.beforeAfterInitialized = 'true';

    const updatePosition = () => {
      comparison.style.setProperty(
        '--position',
        `${range.value}%`
      );
    };

    range.addEventListener(
      'input',
      updatePosition
    );

    range.addEventListener(
      'change',
      updatePosition
    );

    updatePosition();
  });
}

/* =========================
   DEBOUNCE
========================= */

function debounceBeforeAfter(callback, delay) {
  let timeout;

  return function () {
    clearTimeout(timeout);

    timeout = setTimeout(
      callback,
      delay
    );
  };
}